import { Injectable } from '@angular/core';
import { HPMNCountry } from '../model/report/HPMNCountry';
import { HPMNNetwork } from '../model/report/HPMNNetwork';
import { VPMNCountry } from '../model/report/VPMNCountry';
import { VPMNNetwork } from '../model/report/VPMNNetwork';
import { Zone } from '../model/report/Zone';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor() { }

  getHPMNCountry(){
    return[
      new HPMNCountry('Ghana','Ghana')
    ];
  }
  getHPMNNetwork(){
    return[
      new HPMNNetwork('MTN','MTN')
    ];
  }
  getVPMNCountry(){
    return[
    ];
  }
  getVPMNNetwork(){
    return[
    ];
  }
  getZone(){
    return[
      new Zone('ECOWAS','ECOWAS'),
      new Zone('CEMAC','CEMAC')
    ];
  }
}
